import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../Constants';
import './GlobalFooter.scss';
import useLocale from '../../locale/useLocale';

const GlobalFooter = () => {
    const { l } = useLocale();
    const currentYear = new Date().getFullYear();
    const footerContent = `© ${currentYear} ${l('_PwCDisclaimer')}`;

    const navigate = useNavigate();

    const footerClick = (url: string) => {
        navigate(url);
    };
    return (
        <div className="footer-wrapper">
            <footer className="footer" role="contentinfo">
                <p className="footer-disclaimer">
                    © {currentYear} PwC. All rights reserved. PwC refers to the
                    PwC network and/or one or more of its member firms, each of
                    which is a separate legal entity. Please see{' '}
                    <a
                        href="https://www.pwc.com/structure"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        pwc.com/structure
                    </a>{' '}
                    for further details.
                </p>
                <nav className="footer-links" aria-label="Footer links">
                    <a href="#">Legal notices</a>
                    <a href="#">Privacy</a>
                    <a href="#">Cookie policy</a>
                    <a href="#">Legal disclaimer</a>
                    <a href="#">Terms and conditions</a>
                </nav>
            </footer>
        </div>
    );
};

export default GlobalFooter;
